export default __webpack_public_path__ + "static/media/06_RILED-UP.98bea085.png";